import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectDeclarationType } from "../../selectors";
import { motKey } from "../../util/NL_fieldPatterns";


export const useValidateMotUsingDecType=(mot,validateError)=>{
    const declarationType=useSelector(selectDeclarationType)
    const motError=useSelector((state)=>state.ValidationErrors.header?.[motKey]?.msg)
    useEffect(()=>{
        validateError({[`${motKey}`]:""},{transportation:{borderTransitMode:{mot}}},{[`${motKey}`]: {presence:["B","E"].includes(declarationType)? false :{message:"^If value of DECLARATION TYPE is B or E then BORDER TRANSIT MODE is optional else required",allowEmpty:false}}})
    },[declarationType,mot])
    
    return motError
 
}